<script setup>
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import DataTablesButtons from "datatables.net-buttons-bs5";
import DataTablesSelect from "datatables.net-select-bs5";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-fixedcolumns";
import useHardwareReportTable from "@/scripts/Devices/HardwareReportTable";
import { columns } from "@/helpers/hardwareReportTableHelper";

DataTable.use(DataTablesCore);
DataTable.use(DataTablesButtons);
DataTable.use(DataTablesSelect);

const { tableOptions, onSelect, onDeselect, archiveDataTableRef } =
  useHardwareReportTable();
</script>

<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">FILTERED REPORT:</h3>
            </div>
            <div class="table-responsive">
              <div class="card-body">
                <DataTable
                  ref="archiveDataTableRef"
                  id="archived-devices-table"
                  :columns="columns"
                  :options="tableOptions"
                  @select="(event, dt, type) => onSelect({ event, dt, type })"
                  @deselect="
                    (event, dt, type) => onDeselect({ event, dt, type })
                  "
                  class="datatable-css table table-hover table-spacing text-nowrap"
                  width="100%"
                >
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style>
.table-responsive {
  overflow-x: auto;
}
.table-spacing {
  margin: 5px 0 !important;
}
.datatable {
  margin: 10px;
}
button.dt-button.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.datatable-css .dt-scroll-body {
  border-bottom-width: 0px !important;
}
</style>
